module.exports = __webpack_public_path__ + "assets/img/portfolio-11.670ec3e9.png";